/**
 * FaceEmbeddingSource — domain value type + priority rule.
 * Zero external dependencies (domain layer).
 *
 * Priority: local-enrolled > remote-v2
 * A local-enrolled row can NEVER be overwritten by a remote-v2 seed.
 * A remote-v2 row CAN be overwritten by either source (fresh seed or local capture).
 */

export type FaceEmbeddingSource = 'remote-v2' | 'local-enrolled';

/**
 * Pure function encoding the source priority rule.
 * Returns true if the incoming source is allowed to overwrite the existing one.
 *
 * @param existing - source of the row currently in DB, or null if no row exists
 * @param incoming - source of the candidate being written
 */
export function shouldOverwriteEmbedding(
  existing: FaceEmbeddingSource | null,
  _incoming: FaceEmbeddingSource,
): boolean {
  if (existing === null) return true;
  if (existing === 'local-enrolled') return false;
  return true;
}
